import {type Country} from './CountryConverter';
import Countries from './Countries';
import React from 'react';


interface CountryPickerProps {
    selectedCountry: Country;
    onCountryChange: (e: React.ChangeEvent<HTMLSelectElement>) => void;
    visibleText: 'COU_NAME' | 'COU_VORWAHL';
    name?: string;
    className?: string;
}

const CountryPicker: React.FC<CountryPickerProps> = ({ selectedCountry, onCountryChange, visibleText, name, className }) => {
    return (
        <div className={"flex flex-col " + (className ? className : '')}>
            <select
                name={name}
                value={selectedCountry.COU_ID}
                onChange={(e) => {
                    // Parse value to integer before passing to handler
                    const event = {
                        ...e,
                        target: {
                            ...e.target,
                            name: name,
                            value: parseInt(e.target.value, 10)
                        }
                    } as unknown as React.ChangeEvent<HTMLSelectElement>;
                    onCountryChange(event);
                }}
                className="block w-full p-2 border border-gray-300 rounded-md focus:ring-blue-500 focus:border-blue-500"
            >
                {Countries.map((country) => (
                    <option key={country.COU_ID} value={country.COU_ID}>
                        {country.COU_ISO3166_2 ? country.COU_ISO3166_2.toUpperCase().replace(/./g, char => String.fromCodePoint(char.charCodeAt(0)+127397)) : <>&nbsp;&nbsp;&nbsp;&nbsp;</>}
                        &nbsp;&nbsp;&nbsp;
                        {visibleText === 'COU_NAME' && country.COU_NAME}
                        {visibleText === 'COU_VORWAHL' && country.COU_VORWAHL}
                    </option>
                ))}
            </select>
        </div>
    );
}

export default CountryPicker;